import { PricesheetItem } from "src/shared/models/pricesheetitem.model";

export const PricesheetItemSerializer = {
  fromJson(json: any): PricesheetItem {
    return new PricesheetItem(json);
  },

  fromJsonList(json: any[]): PricesheetItem[] {
    return json.map((item) => new PricesheetItem(item));
  },
};